// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import { FormSelect, FormRadio } from '../../../../components/index';
import { SQUAD_SIZE, league_tooltips } from '../../../../helpers/index';

type Props = {
	league: {
		status: string,
		draft_status: string,
	}
};

export const GameplaySettings = ({ league }: Props) => (
	<div>

		<Field
			label='Squad Size & Layout'
			name='squad_size'
			options={SQUAD_SIZE}
			component={FormSelect}
			tooltip={league_tooltips.squad_size}
			is_disabled={league.status !== 'scheduled' || league.draft_status !== 'scheduled'}
		/>

		<FormRadio
			label='Captains'
			name='captains'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.captains}
			is_disabled={league.status !== 'scheduled'}
		/>

		<FormRadio
			label='Emergencies'
			name='emergency'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.emergency}
			is_disabled={league.status !== 'scheduled'}
		/>

		<FormRadio
			label='Rolling Lockout'
			name='lockout'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.lockout}
			is_disabled={league.status !== 'scheduled'}
		/>
	</div>
);

export default GameplaySettings;


// WEBPACK FOOTER //
// ./src/pages/league/leagueSettings/forms/GameplaySettings.js